import { useState } from 'react';

export interface ToastMessage {
  title: string;
  description: string;
}

export const useToast = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [toastContent, setToastContent] = useState<ToastMessage>({
    title: '',
    description: '',
  });

  const openToast = (message: ToastMessage) => {
    setToastContent(message);
    setIsOpen(true);
  };

  const closeToast = () => {
    setIsOpen(false);
  };

  return {
    isToastOpen: isOpen,
    toastContent,
    openToast,
    closeToast,
  };
};
